import React from 'react';
import { LinkProps, Link as MuiLink } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';

export const Link = styled(
    ({ to, ref, ...other }: Omit<LinkProps<typeof RouterLink, { to: string }>, 'component'> & { to: string }) =>
        <MuiLink innerRef={ref} to={to} component={RouterLink} {...other} />
)`
    ${({ theme }) => `
        font-size: ${theme.typography.pxToRem(18)};
        display: flex;
        align-content: center;
    `}
`;

export const PaddedInfoIcon = styled(InfoIcon)`
    ${({ theme }) => `
        padding: 0 ${theme.spacing(1)}px;
        && {
            width: inherit;
        }
    `}
`;

export const PaddedWarningIcon = styled(WarningIcon)`
    ${({ theme }) => `
        padding: 0 ${theme.spacing(1)}px;
        && {
            width: inherit;
        }
    `}
`;